import Vue from 'vue';
import VueI18n, { LocaleMessages, NumberFormats } from 'vue-i18n';
import getBrowserLocale, { currencyDisplay, findSupportedLocale } from '@/utils/i18n-helpers';

Vue.use(VueI18n as any);

/**
 * All three locales seed CAD so the pre-restaurant default matches FALLBACK_CURRENCY.
 * The applyCurrencyToI18n util function will then override the currencies with the actual currency derived from the location's address.
 */
const numberFormats: NumberFormats = {
	'en-CA': {
		currency: {
			style: 'currency',
			currency: 'CAD',
			currencyDisplay
		}
	},
	'en-GB': {
		currency: {
			style: 'currency',
			currency: 'CAD',
			currencyDisplay
		}
	},
	'fr-CA': {
		currency: {
			style: 'currency',
			currency: 'CAD',
			currencyDisplay
		}
	}
};

function loadLocaleMessages (): LocaleMessages {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
	const messages: LocaleMessages = {};
	locales.keys().forEach((key: string) => {
		// Match pattern like "./en-CA/auth.json" or "./fr-CA/menus.json"
		const matched = key.match(/\.\/([A-Za-z0-9-_]+)\/([A-Za-z0-9-_]+)\.json$/i);
		if (matched && matched.length > 2) {
			const locale = matched[1]; // e.g., "en-CA"
			const namespace = matched[2]; // e.g., "auth"

			if (!messages[locale]) {
				messages[locale] = {};
			}

			messages[locale][namespace] = locales(key);
		}
	});
	return messages;
}

const envFallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || '';
export default new (VueI18n as any)({
	locale: getBrowserLocale(),
	fallbackLocale: findSupportedLocale(envFallbackLocale, envFallbackLocale)?.code || 'en-CA',
	silentFallbackWarn: true, // Some locales only contain the strings that differ from the global/generic ones on purpose, fallback warnings are not needed
	messages: loadLocaleMessages(),
	numberFormats
});
